import Api from './api'
import { getXUserKey } from '@/plugins/account'
import { getXAPIEnv } from '@/plugins/account'

export default class AddressAPI {
    static async request(params) {
        return await Api(
            'address',
            params.endpoint,
            params.method || 'get',
            params.data || {},
            params.headers || { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() },
            params.loading !== undefined ? params.loading : true
        )
    }

    static async autoCompleteAddress(query, sessionToken, loading = false) {
        return await AddressAPI.request({
            endpoint: 'autocomplete',
            loading: loading,
            data: {
                q: query,
                token: sessionToken
            }
        })
    }

    static async addressDetail(placeId, sessionToken, loading = false) {
        return await AddressAPI.request({
            endpoint: `detail/${placeId}`,
            loading: loading,
            data: { token: sessionToken }
        })
    }

    static async addressDDD(shortState, city, loading = false) {
        return await AddressAPI.request({
            endpoint: `city/ddd/${shortState}/${city}`,
            loading: loading
        })
    }
}
